<template>
  <form class="" @submit.prevent="handleSubmit">
    <div class="form-group">
      <div
        class="alert text-left formatted-text"
        :class="{
          'alert-danger': message.error,
          'alert-success': !message.error,
        }"
        role="alert"
        v-show="message.display"
      >
        {{ this.message.content }}
      </div>
    </div>
    <div class="form-group col-md-6">
      <label for="name">Nom</label>
      <input
        v-model="country.name"
        type="text"
        class="form-control"
        :class="{ 'is-invalid': submitted && !country.name }"
        id="name"
        placeholder="Nom"
      />
      <div v-show="submitted && !country.name" class="invalid-feedback">
        Nom requis
      </div>
    </div>
    <div class="form-group col-md-6">
      <label for="code_iso">Code ISO</label>
      <input
        v-model="country.code_iso"
        type="text"
        class="form-control"
        :class="{ 'is-invalid': submitted && !country.code_iso }"
        id="code_iso"
        placeholder="code iso"
      />
      <div v-show="submitted && !country.code_iso" class="invalid-feedback">
        Code ISO requis
      </div>
    </div>

    <!-- <div class="form-group col-md-6">
      <label for="state">Etat</label>
      <select
        id="state"
        class="form-control"
        :class="{ 'is-invalid': submitted && !country.state }"
        v-model="country.state"
      >
        <option disabled value="">Sélectionner un état...</option>
        <option value="AUTHORIZED">AUTHORISE</option>
        <option value="UNAUTHORIZED">NON AUTHORISE</option>
      </select>
      <div v-show="submitted && !country.state" class="invalid-feedback">
        Etat requis
      </div>
    </div> -->
    <div class="form-group col-md-6">
      <label for="indicatif">Indicatif</label>
      <input
        v-model="country.indicative"
        type="number"
        class="form-control"
        :class="{ 'is-invalid': submitted && !country.indicative }"
        id="indicatif"
        placeholder="Indicatif"
      />
      <div v-show="submitted && !country.indicative" class="invalid-feedback">
        Indicatif requis
      </div>
    </div>
    <div class="form-group col-md-6">
      <div class="form-check">
        <input
          v-model="country.state"
          class="form-check-input"
          type="checkbox"
          id="state"
        />
        <label class="form-check-label" for="state"> Etat </label>
      </div>
    </div>
    <div class="form-group col-md-6">
      <div class="form-check">
        <input
          v-model="country.automatic_visa_generation"
          class="form-check-input"
          type="checkbox"
          id="automatic_visa_generation"
        />
        <label class="form-check-label" for="automatic_visa_generation">
          Génération automatique de visa ?
        </label>
      </div>
    </div>
    <button type="submit" class="btn btn-primary">Enrégister</button>
    <router-link
      class="btn btn-dark action-btn-cancel"
      :to="{ name: 'countries' }"
    >
      Retourner
    </router-link>
  </form>
</template>

<script>
import { CREATE_COUNTRY } from "@/store/actions.type";
import { SET_LOADING } from "@/store/mutations.type";
import { SUCCESS_MESSAGE } from "@/helpers/messages";

export default {
  name: "CountryForm",
  data() {
    return {
      country: {
        name: "",
        state: true,
        code_iso: "",
        indicative: "",
        automatic_visa_generation: true,
      },
      submitted: false,
      message: {
        error: false,
        display: false,
        content: "",
      },
    };
  },
  methods: {
    handleSubmit() {
      // affichage réinitialisé
      this.message.display = false;
      this.message.error = false;

      // variable de soumission initialisée
      this.submitted = true;

      const { name, code_iso, indicative } = this.country;
      if (!name || !code_iso || !indicative) {
        return;
      }

      this.$store.commit(SET_LOADING, true);

      this.$store
        .dispatch(CREATE_COUNTRY, this.country)
        .then(() => {
          this.message.content = SUCCESS_MESSAGE;
          this.message.display = true;

          //On réinitialise l'état
          this.country = {
            name: "",
            state: true,
            code_iso: "",
            indicative: "",
            automatic_visa_generation: true,
          };
          this.submitted = false;
        })
        .catch((error) => {
          this.message.content = `${error} \n ${JSON.stringify(error.errors)}`;
          this.message.display = true;
          this.message.error = true;
          this.submitted = false;
        })
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
  },
};
</script>